import FetchHelpers from "utils/FetchHelpers";
import { externalRoutes } from "routes";

export default {
  get() {
    const url = externalRoutes.menu("mega-menu");
    return FetchHelpers.get(url);
  },
};
